import type { WizardPageViewModel } from 'src/lib/wizard/ui/wizardPageViewModel';
import { TasteWheelWizard } from 'src/lib/assets/graphics';
import { WheelText } from 'src/lib/common/ui/WheelText';
import styles from './VisualisationGraphic.module.scss';

interface VisualisationGraphicProps {
  stepName: string,
  viewModel: WizardPageViewModel,
  selectedFlavourIds: string[],
  selectedTasteIds: string[],
  selectedMouthfeelIds: string[],
}

export function VisualisationGraphic(props: VisualisationGraphicProps) {

  // prepare flavour, taste and mouthfeel values for the svg:
  // -> pipe symbols in front and after each value to make
  //    css selectors based on these IDs more robust
  const flavourString = `|${props.selectedFlavourIds.join('|')}|`;
  const tasteString = `|${props.selectedTasteIds.join('|')}|`;
  const mouthfeelString = `|${props.selectedMouthfeelIds.join('|')}|`;

  return (
    <div
      data-step={ props.stepName }
      data-flavourids={ flavourString }
      data-tasteids={ tasteString }
      data-mouthfeelids={ mouthfeelString }
      className={ styles.svgHolder }
      aria-hidden="true">
      <TasteWheelWizard />
      <WheelText variant="wizard" />
    </div>
  );
}
